import SelectInput from "./SelectInput";

export type {SelectInputProps} from "./SelectInput";

export default SelectInput;
